import { render, staticRenderFns } from "./TheRightArea.vue?vue&type=template&id=65cf69ea&scoped=true"
import script from "./TheRightArea.vue?vue&type=script&lang=ts"
export * from "./TheRightArea.vue?vue&type=script&lang=ts"
import style0 from "./TheRightArea.vue?vue&type=style&index=0&id=65cf69ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.18.1_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cf69ea",
  null
  
)

export default component.exports